import { useGetOtaTeamStatisticsQuery } from '@app/api/statistics'
import PricingVersionGate from '@app/components/PricingVersionGate'
import { bytesToGibs } from '@app/utils/unitConversion'
import { Spacer } from '@lokalise/louis'
import type { FC } from 'react'
import { useState } from 'react'

import OtaUsageAboveLimitAlert from './OtaUsageAboveLimitAlert'
import OtaUsageAboveThresholdAlert from './OtaUsageAboveThresholdAlert'

type OtaUsageLimitAlertProps = {
	teamId: number
	teamUuid?: string
	usageLimit: number
}

const OTA_BANNER_USAGE_THRESHOLD = 80

const OtaUsageLimitAlert: FC<OtaUsageLimitAlertProps> = ({ teamId, teamUuid, usageLimit }) => {
	const { data: otaStatisticsData, isLoading } = useGetOtaTeamStatisticsQuery(
		{ teamId },
		{ skip: !teamId },
	)
	const [open, setOpen] = useState<boolean>(true)
	const totalTrafficInGiBs = bytesToGibs(otaStatisticsData?.totalTraffic ?? 0)

	if (isLoading || !totalTrafficInGiBs || !open || !teamUuid) {
		return null
	}

	const percentageUsage = (totalTrafficInGiBs / usageLimit) * 100

	if (percentageUsage <= OTA_BANNER_USAGE_THRESHOLD) {
		return null
	}

	return (
		<PricingVersionGate teamUuid={teamUuid} renderFor="v1">
			<Spacer top={3}>
				{percentageUsage > 100 ? (
					<OtaUsageAboveLimitAlert
						usageLimit={usageLimit}
						totalTrafficInGiBs={totalTrafficInGiBs}
						percentageUsage={percentageUsage}
						threshold={OTA_BANNER_USAGE_THRESHOLD}
						onClose={() => setOpen(false)}
					/>
				) : (
					<OtaUsageAboveThresholdAlert
						usageLimit={usageLimit}
						percentageUsage={percentageUsage}
						threshold={OTA_BANNER_USAGE_THRESHOLD}
						totalTrafficInGiBs={totalTrafficInGiBs}
						onClose={() => setOpen(false)}
					/>
				)}
			</Spacer>
		</PricingVersionGate>
	)
}

export default OtaUsageLimitAlert
